import { faqItems } from './mockData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-4">
              <i className="ri-question-answer-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">答疑解惑</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              关于4K观影的常见疑问，这里都有答案
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div key={item.id} className="bg-background-100 rounded-2xl overflow-hidden">
                <details className="group">
                  <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                    <h3 className="font-bold text-foreground-900 text-sm md:text-base pr-4">
                      {item.q}
                    </h3>
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 flex-shrink-0 group-open:bg-primary-100 transition-colors">
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform text-sm"></i>
                    </div>
                  </summary>
                  <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                    <p className="text-sm text-foreground-500 leading-relaxed border-t border-background-200 pt-4">
                      {item.a}
                    </p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}